import React from 'react';
import Box from '@cloudscape-design/components/box';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { brand } from '../theme/brand';

interface AuthCardProps {
    title: string;
    subtitle?: string;
    children: React.ReactNode;
}

/**
 * Centers an authentication card (sign in / register / confirm) in the page
 * with a consistent width, the "Supplier Gateway" product wordmark, and a
 * heading. The auth screens show the product name (Supplier Gateway) rather
 * than the org wordmark (Tech Supply Chain) used in the app masthead.
 */
export default function AuthCard({ title, subtitle, children }: AuthCardProps) {
    return (
        <Box padding="xxl">
            <div style={{ maxWidth: 440, margin: '0 auto' }}>
                <Container
                    header={
                        <SpaceBetween size="s">
                            <Box textAlign="center">
                                <span
                                    style={{
                                        fontWeight: 800,
                                        fontSize: 28,
                                        letterSpacing: 0.5,
                                        color: brand.navy,
                                    }}
                                >
                                    Supplier Gateway
                                </span>
                            </Box>
                            <Header variant="h2" description={subtitle}>
                                {title}
                            </Header>
                        </SpaceBetween>
                    }
                >
                    {children}
                </Container>
            </div>
        </Box>
    );
}

AuthCard.defaultProps = {
    subtitle: undefined,
};
